<template>
    <!-- <CustomHeader :text="$t('accFund.mainTitle')" /> -->
    <div class="fund-container">
        <div class="topImg" />
        <div class="secondTopImg">
            <img src="@/assets/accFund/nobuy_bg.png" alt="">
        </div>

        <div class="collapse-container">
            <van-collapse v-model="activeName" accordion>
                <van-collapse-item name="1">
                    <template #title>
                        <div>
                            <span style="font-size: 15px;">{{ $t('accFund.invest') }}   </span> 
                            <span style="font-size: 21px;font-weight: bold;"> {{ investAmount }} </span>
                            <span style="font-size: 15px;"> {{ $t('accFund.andGet') }}   </span>
                            <span style="font-size: 21px;color: #e000a0; font-weight: 700;">  {{ resultAmount }}</span></div>
                    </template>
                    <p style="text-align: center;margin: 4px 0px;font-size: 12px;">{{ $t('accFund.rewardPlan') }}</p>
                    <div class="table-container">
                        <!-- Table Header -->
                        <van-row class="table-header" type="flex" justify="space-between">
                            <van-col span="8" class="table-data"><strong>{{ $t('accFund.time') }}</strong></van-col>
                            <van-col span="8" class="table-data"><strong>{{ $t('accFund.amountReceived') }}</strong></van-col>
                            <van-col span="8" class="table-data"><strong>{{ $t('accFund.gameFlow') }}</strong></van-col>
                        </van-row>

                        <!-- Table Rows -->
                        <van-row v-for="(item, index) in tableData"
                            :class="['table-row', index % 2 !== 0 ? 'row-dark' : 'row-light', index === tableData.length - 1 ? 'last-row' : '']"
                            :key="index" type="flex" justify="space-between">
                            <van-col span="8" class="table-data">{{ item.tempo }}</van-col>
                            <van-col span="8" class="table-data">{{ item.montante }}</van-col>
                            <van-col span="8" class="table-data">{{ item.fluxo }}</van-col>
                        </van-row>
                    </div>
                </van-collapse-item>
                <van-collapse-item title="Title2" name="2">
                    {{ $t('accFund.title') }}
                </van-collapse-item>
            </van-collapse>
        </div>
    </div>


</template>

<script setup lang="ts">
// import CustomHeader from '@/components/common/customHeader.vue'
import { ref } from 'vue';
import InputField from './components/inputField.vue';
import AmountCard from './components/amountCard.vue';
// import MainButton from '@/components/common/mainButton.vue';

const activeName = ref('1');
const tableData = [
    { tempo: 'Day 1', montante: 'R$ 10', fluxo: '3 X' },
    { tempo: 'Day 2', montante: 'R$ 1', fluxo: '8 X' },
    { tempo: 'Day 3', montante: 'R$ 1', fluxo: '8 X' },
    { tempo: 'Day 4', montante: 'R$ 1', fluxo: '8 X' },
    { tempo: 'Day 5', montante: 'R$ 1', fluxo: '8 X' },
    { tempo: 'Day 6', montante: 'R$ 1', fluxo: '8 X' },
    { tempo: 'Day 7', montante: 'R$ 1', fluxo: '8 X' },
    { tempo: 'Day 8', montante: 'R$ 1', fluxo: '8 X' },
    { tempo: 'Day 9', montante: 'R$ 1', fluxo: '8 X' },
    { tempo: 'Day 10', montante: 'R$ 2', fluxo: '10 X' }
]
const investAmount = ref(10);
const resultAmount = ref(20);

</script>
<style scoped>
::v-deep .van-cell__right-icon {
    display: none !important;
}

::v-deep .van-cell {
    background-image: url('@/assets/accFund/nobuy_item_bg.png') !important;
    background-repeat: round;
    background-color: transparent !important;
    background-size: cover;
    margin-top: 10px;
}

::v-deep .van-collapse-item__content {
    --van-collapse-item-content-background: transparent !important;
    color: #fff !important;
    padding: 0px !important;
    border: .19rem solid hsla(0, 0%, 100%, .25) !important;
    border-top: none !important;
    border-radius: 0 0 1rem 1rem !important;
}

.table-container {
    background: transparent;
    border-radius: 12px;
    max-width: 400px;
    margin: 2px 14px;
    font-family: sans-serif;
    color: white;
}

.table-header {
    font-size: 10px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.3);
    padding: 5px 0px;
    background: hsla(0, 0%, 100%, .15);
    border-radius: 10px 10px 0px 0px;
}

.table-row {
    padding: 4px 0;
    font-size: 12px;
}

.row-dark {
    background-color: hsl(258.89deg 100% 78.82%);
}

.row-light {
    background-color: transparent;
}

.fund-container {
    background-image: linear-gradient(rgb(209, 127, 255) 1%, rgb(127, 153, 255) 100%);
    min-height: 100vh;
}

.topImg {
    background-image: url('@/assets/accFund/fundo_top_bg.png');
    background-repeat: no-repeat;
    background-size: cover;
    height: 32vh;
    width: 100%;
}

.secondTopImg {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    position: relative;
    background-color: transparent;
}

.secondTopImg img {
    max-width: 85%;
    max-height: 100%;
    object-fit: contain;
}

.collapse-container {
    display: flex;
    justify-content: center;
    padding: 0px 15px;
    flex-direction: column;
}

.table-data {
    align-items: center;
    text-align: center;
}

.last-row {
    border-radius: 0px 0px 10px 10px;
    margin-bottom: 20px;
}
</style>